export var desktopInnerWidth = 328;
export var systemicBreakpoints = {
    mobile: 320,
    tablet: 768,
    desktop: 1024,
};
export var Device = {
    Mobile: "@media (max-width: ".concat(systemicBreakpoints.tablet - 1, "px) and (min-width: ").concat(systemicBreakpoints.mobile, "px)"),
    Tablet: "@media (max-width: ".concat(systemicBreakpoints.desktop - 1, "px) and (min-width: ").concat(systemicBreakpoints.tablet, "px)"),
    Desktop: "@media (min-width: ".concat(systemicBreakpoints.desktop, "px)"),
    MobileAndTablet: "@media (max-width: ".concat(systemicBreakpoints.desktop - 1, "px)"),
    TabletAndDesktop: "@media (min-width: ".concat(systemicBreakpoints.tablet, "px)"),
};
//# sourceMappingURL=_variables.js.map